import * as React from "react";
const SvgOrg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="org_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path d="M111.205 957.99v-37.289H912.85v37.29H111.205m577.931-55.934h-93.215l-.39-478.96-111.465-80.327-261.004 111.863v447.424H111.205v-37.284h74.57V435.992l298.29-130.506L633.21 417.343v447.429h55.926v37.285zM278.211 512.629l131.28-57.996v74.569l-130.5 55.933-.78-72.506zm131.28 109.789v74.573l-130.5 37.28-.78-70.427 131.28-41.426zm-130.5 186.43 130.5-37.288v93.213h-130.5v-55.924zM726.42 156.345v745.712h55.931V222.345l-55.93-66.001zm-242.353 242.36v503.353h55.927V435.992l-55.927-37.287zM912.85 902.058h-93.216V212.273L726.42 100.412 372.206 249.557v55.929l-37.288 37.284V230.912L745.065 63.128l111.858 149.146v652.499h55.927v37.284z" />
  </svg>
);
export default SvgOrg;
